import { render, staticRenderFns } from "./VideoPreviewAndDisplay.vue?vue&type=template&id=be32646c&scoped=true&"
import script from "./VideoPreviewAndDisplay.vue?vue&type=script&lang=js&"
export * from "./VideoPreviewAndDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPreviewAndDisplay.vue?vue&type=style&index=0&id=be32646c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be32646c",
  null
  
)

export default component.exports